import Quill from 'quill'
import { htmlIded, htmlTagged } from './fun-js-lib/html'
import { setPageHasChanges } from './page-has-changes'
import { isEditedBySupervisor } from './validation/signValidation'

export function initQuill () {
  let toolbarOptions = [
    [{ 'header': [1, 2, 3, 4, 5, false] }],
    ['bold', 'italic', 'underline'],        // toggled buttons (underline removed)
    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ align: '' }, { align: 'justify' }],
  ]

  const Delta = Quill.import('delta')

  // Init the Quill RTE

  if (document.querySelector('#editor-container') != null) {
    updateQuillFromInput()
    const isMeasurementEditor = document.getElementById('measurement-quill-input') !== null
    let quillMaster = new Quill('#editor-container', {
      modules: {
        toolbar: toolbarOptions,
        keyboard: {
          bindings: keybindingsFixFirefoxJustify()
        }
      },
      // Explicitly whitelist formats and exclude images
      formats: [
        'header', 'bold', 'italic', 'underline',
        'list', 'align'
      ],
      theme: 'snow',
      placeholder: isMeasurementEditor ? 'Dodajte opis ovde...' : '',
    })
    // Prevent images via pasted HTML (strip any <img> tags)
    quillMaster.clipboard.addMatcher('img', function () { return new Delta() })

    // Block image pastes from clipboard (files or images in clipboard)
    const editorRoot = quillMaster.root
    editorRoot.addEventListener('paste', function (e) {
      const items = e.clipboardData && e.clipboardData.items
      if (items && Array.from(items).some(item => item.type && item.type.startsWith('image/'))) {
        e.preventDefault()
      }
    })

    // Block image drag-and-drop into the editor
    editorRoot.addEventListener('drop', function (e) {
      const files = e.dataTransfer && e.dataTransfer.files
      if (files && Array.from(files).some(file => file.type && file.type.startsWith('image/'))) {
        e.preventDefault()
      }
    })
    quillMaster.on('text-change', function () {
      setInputToValue()
      setPageHasChanges()
    })
    quillMaster.on('text-change', function () {
      if (document.getElementById("save-button") != null) {
        document.getElementById("save-button").classList.remove('invisible');
      }
    })
    if (isMeasurementEditor) {
      quillMaster.root.setAttribute('data-placeholder', 'Dodajte opis ovde...');
    }
  }
  if (document.querySelector('#editor-container-helper1') != null) {
    new Quill('#editor-container-helper1', {
      modules: {
        toolbar: null
      },
      theme: 'snow',
      readOnly: true,
    });
  }
  if (document.querySelector('#editor-container-helper2') != null) {
    new Quill('#editor-container-helper2', {
      modules: {
        toolbar: null
      },
      theme: 'snow',
      readOnly: true,
    });
  }
}

/**
 * This function returns keybinding for space (only for Firefox browser)
 * that fixes strange behavior in justified text: when user presses space
 * Quill doesn't actually add space to text (though caret moves by one step)
 */
function keybindingsFixFirefoxJustify () {
  let keyBindings = {}
  let isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  if (isFirefox) {
    keyBindings.justifiedTextSpacebarFixForFirefox = {
      key: ' ',
      format: { align: 'justify' },
      suffix: /^$/,
      handler: function (range) {
        this.quill.insertText(range.index, ' ', 'user');
        return true;
      }
    };
  }
  return keyBindings
}

/**
 * Updates quill on page load using input.
 * For the reason unknown, quill sometimes doesn't update its content
 * on page refresh. Its hidden input is always updated correctly, however.
 */
function updateQuillFromInput () {
  const isMeasurementEditor = htmlIded('measurement-quill-input') !== null
  let element = isEditedBySupervisor() ?
    htmlIded('remarks-quill-input') :
    htmlIded('work-description-quill-input')
  element = element ?? htmlIded('measurement-quill-input')
  let value = element.value
  htmlIded('editor-container').innerHTML = (value === '' ? (isMeasurementEditor ? '': '<p class="ql-align-justify"> </p>') : JSON.parse(value).html)
}

function setInputToValue () {
  let editorContainer = document.querySelector('#editor-container')
  let data = {
    html: editorContainer.children[0].innerHTML
  }
  // This gives you a string in JSON syntax of the object above that you can
  // send with XMLHttpRequest.
  let json = JSON.stringify(data);
  let dataHolder = htmlTagged(editorContainer.parentElement, 'input')
    .filter(input => input.classList.contains('quill-hidden-input'))[0]
  dataHolder.value = json
  dataHolder.dispatchEvent(new Event('input'))
}
